import { z } from "zod"
import { LegacyCompatibleDiscountSchema } from "./discount"

export const ServiceWashSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  price: z.number().positive(),
  description: z.string().nullable(),
  isBookable: z.boolean(),
  /** Estimated minutes of work; 15 unless the store sets otherwise. */
  durationMinutes: z.number().int().nonnegative(),
})

export const ServiceWashWithoutBookabilitySchema = ServiceWashSchema.omit({
  isBookable: true,
  durationMinutes: true,
})

export const ServiceWashSnapshotSchema =
  ServiceWashWithoutBookabilitySchema.omit({
    id: true,
  }).extend({
    originalWashId: z.string().uuid(),
    snapshotWashId: z.string().uuid(),
    /** Per-line discount in percent (0-100), or null if no discount. */
    laborPriceDiscount: LegacyCompatibleDiscountSchema.nullable(),
    isMandatory: z.boolean(),
    requiredPartIds: z.array(z.string().uuid()),
    requiredManualServiceActionIds: z.array(z.string().uuid()),
  })

export const CreateServiceWashSchema = ServiceWashSchema.omit({
  id: true,
}).extend({
  durationMinutes: z.number().int().nonnegative().default(15),
})
export const UpdateServiceWashSchema = CreateServiceWashSchema.partial()

export const WashAlternativeSchema = z.object({
  originalWashId: z.string().uuid(),
  snapshotWashId: z.string().uuid(),
  name: z.string().min(1),
  price: z.number().nonnegative(),
  /** Per-line discount in percent (0-100), or null if no discount. */
  laborPriceDiscount: LegacyCompatibleDiscountSchema.nullable(),
  description: z.string().nullable(),
  isRecommended: z.boolean(),
  requiredPartIds: z.array(z.string().uuid()),
  requiredManualServiceActionIds: z.array(z.string().uuid()),
})

export const WashAlternativesGroupSchema = z.object({
  id: z.string().uuid(),
  isMandatory: z.boolean(),
  comment: z.string().nullable(),
  alternatives: z.array(WashAlternativeSchema).min(1),
})

export type ServiceWash = z.infer<typeof ServiceWashSchema>
export type ServiceWashWithoutBookability = z.infer<
  typeof ServiceWashWithoutBookabilitySchema
>
export type ServiceWashSnapshot = z.infer<typeof ServiceWashSnapshotSchema>
export type CreateServiceWash = z.infer<typeof CreateServiceWashSchema>
export type UpdateServiceWash = z.infer<typeof UpdateServiceWashSchema>
export type WashAlternative = z.infer<typeof WashAlternativeSchema>
export type WashAlternativesGroup = z.infer<typeof WashAlternativesGroupSchema>
